import sun from "../../public/images/sun.svg";
import moon from "../../public/images/moon1.svg";

document.addEventListener("DOMContentLoaded", () => {
  // initialize theme
  const theme = localStorage.getItem("theme") || "light";
  applyTheme(theme);

  // change icon and listen to click
  changeThemeIcon();
  handleScrollToTop();
  loadFooterDate();
});

// change theme icon
function changeThemeIcon() {
  const themeButton = document.getElementById("theme-toggle-button");
  const icon = document.querySelector(".theme__icon");
  if (themeButton && icon) themeButton.addEventListener("click", toggleTheme);
}

// sync all instance of browsers to reflect theme switch on all window
window.addEventListener("storage", (e) => {
  if (e.key === "theme" && e.newValue) applyTheme(e.newValue);
});

function toggleTheme() {
  const next = localStorage.getItem("theme") === "light" ? "dark" : "light";
  localStorage.setItem("theme", next);
  applyTheme(next);
}

function applyTheme(mode) {
  const html = document.documentElement;
  const icon = document.querySelector(".theme__icon");
  const metaTheme = document.querySelector('meta[name="theme-color"]');
  html.setAttribute("data-theme", mode);
  metaTheme?.setAttribute("content", mode === "dark" ? "#343434" : "#235789");
  document
    .getElementById("theme-toggle-button")
    ?.setAttribute("aria-pressed", mode === "dark" ? "true" : "false");

  icon?.classList.toggle("theme__icon--dark", mode === "dark");
  if (icon) {
    if (mode === "dark") {
      icon.src = sun;
      icon.alt = "Sun icon for light mode";
    } else {
      icon.src = moon;
      icon.alt = "Moon icon for dark mode";
    }
  }
}

function loadFooterDate() {
  const months = {
    0: "January",
    1: "February",
    2: "March",
    3: "April",
    4: "May",
    5: "June",
    6: "July",
    7: "August",
    8: "September",
    9: "October",
    10: "November",
    11: "December",
  };

  const date = new Date(),
    year = date.getFullYear(),
    currentMonth = months[date.getMonth()],
    dayDate = date.getDate();

  const footerDate = document.querySelector(".footer__date");

  const footerDay = document.querySelector(".footer__date-day");
  if (footerDate) footerDate.textContent = year;

  if (footerDay) footerDay.textContent = `${currentMonth} ${dayDate}`;
}

function handleScrollToTop() {
  let currentY = window.scrollY;

  const scrollDiv = document.querySelector(".scroll");
  const scrollButton = document.querySelector(".scroll__button");
  if (currentY === 0 && scrollDiv) {
    scrollDiv.style.display = "none";
  }
  // hide or show scroll button;
  window.addEventListener("scroll", () => {
    let scrollVisibilityThreshold = 30;
    if (currentY > scrollVisibilityThreshold && scrollDiv) {
      scrollDiv.style.display = "block";

      currentY = window.scrollY;
      return;
    }
    scrollButton.setAttribute("aria-pressed", "false");
    scrollDiv.style.display = "none";
    currentY = window.scrollY;
  });

  //listen to event;
  if (scrollDiv) {
    scrollDiv.addEventListener("click", () => {
      scrollButton.setAttribute("aria-pressed", "true");
      window.scrollTo(0, 0);
    });
  }
}
